import {ColumnsFieldsNames, ReportColumn} from '../types';
import {Report} from '../stores/ReportStore';
import texts from '../texts';

export const fieldTableValidation = (currentReport: Report): string => {
    const {columns, setColumns} = currentReport;

    const errorTypes = [];
    const validatedColumns: ReportColumn[] = columns.map(col => {
        const errors = validateColumn(col);
        errorTypes.push(...errors);

        return {...col, error: errors?.length ? errors : null};
    });
    setColumns(validatedColumns);

    const generalError = generalValidation(columns);
    if (generalError) {
        return generalError;
    }

    return buildErrorMessage(errorTypes);
};

const validateColumn = (column: ReportColumn): ColumnsFieldsNames[] => {
    const {Expr, Width} = column;

    const col = {...column};
    const errors: ColumnsFieldsNames[] = [];

    if (col.IsExpression && !Expr) {
        errors.push(ColumnsFieldsNames.Expr);
    }

    if (!Number(Width)) {
        errors.push(ColumnsFieldsNames.Width);
    }

    return errors;
};

const generalValidation = (columns: ReportColumn[]) => {
    if (columns.length === 1 && columns[0].IsCompany) {
        return texts.onlyCompFieldError;
    }
    return null;
};

const buildErrorMessage = (errors: ColumnsFieldsNames[]): string => {
    const uniqueErrorsType = new Set(errors);
    if (
        uniqueErrorsType.has(ColumnsFieldsNames.Expr) &&
        uniqueErrorsType.has(ColumnsFieldsNames.Width)
    ) {
        return texts.validationMsgWidthAndExpr;
    }

    if (uniqueErrorsType.has(ColumnsFieldsNames.Expr)) {
        return texts.validationMsgExpr;
    }

    if (uniqueErrorsType.has(ColumnsFieldsNames.Width)) {
        return texts.validationMsgWidth;
    }

    return null;
};
